// Copyright (c) 2021-2024 Stockbit All rights reserved.

// @generated by protoc-gen-es v1.10.0 with parameter "target=js+dts"
// @generated from file social/stream/entity/v1/entity.proto (package social.stream.entity.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { proto3, Timestamp } from "@bufbuild/protobuf";
import { FrameType } from "../../data/v1/image_pb.js";
import { SpamStatus } from "../../data/v1/spam_pb.js";

/**
 * @generated from message social.stream.entity.v1.Polling
 */
export const Polling = /*@__PURE__*/ proto3.makeMessageType(
  "social.stream.entity.v1.Polling",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "status", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "created_date", jsonName: "created_date", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "start_date", jsonName: "start_date", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "end_date", jsonName: "end_date", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "question", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "options", kind: "message", T: PollingOptions, repeated: true },
    { no: 8, name: "expired", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 9, name: "message_expired", jsonName: "message_expired", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 10, name: "total_voters", jsonName: "total_voters", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 11, name: "my_vote", jsonName: "my_vote", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 12, name: "ispinned", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
);

/**
 * @generated from message social.stream.entity.v1.ImageData
 */
export const ImageData = /*@__PURE__*/ proto3.makeMessageType(
  "social.stream.entity.v1.ImageData",
  () => [
    { no: 1, name: "image", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "width", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "height", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 4, name: "ratio", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 5, name: "frame", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "frame_type", jsonName: "frame_type", kind: "enum", T: proto3.getEnumType(FrameType) },
  ],
);

/**
 * @generated from message social.stream.entity.v1.PollingOptions
 */
export const PollingOptions = /*@__PURE__*/ proto3.makeMessageType(
  "social.stream.entity.v1.PollingOptions",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "value", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "count_voters", jsonName: "count_voters", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
);

/**
 * @generated from message social.stream.entity.v1.TargetPrice
 */
export const TargetPrice = /*@__PURE__*/ proto3.makeMessageType(
  "social.stream.entity.v1.TargetPrice",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "voted", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "symbol", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "symbol2", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "tradeable", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 7, name: "last_price", jsonName: "last_price", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 8, name: "current_price", jsonName: "current_price", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 9, name: "target_price", jsonName: "target_price", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 10, name: "duration", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 11, name: "day_left", jsonName: "day_left", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 12, name: "agree", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 13, name: "disagree", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 14, name: "hit", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
);

/**
 * @generated from message social.stream.entity.v1.MaskHtml
 */
export const MaskHtml = /*@__PURE__*/ proto3.makeMessageType(
  "social.stream.entity.v1.MaskHtml",
  () => [
    { no: 1, name: "mask", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "tag", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "text", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "attr", kind: "message", T: MaskAttr },
  ],
);

/**
 * @generated from message social.stream.entity.v1.MaskAttr
 */
export const MaskAttr = /*@__PURE__*/ proto3.makeMessageType(
  "social.stream.entity.v1.MaskAttr",
  () => [
    { no: 1, name: "class", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "data_company", jsonName: "data_company", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "data_user", jsonName: "data_user", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "data_insider", jsonName: "data_insider", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "href", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "target", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message social.stream.entity.v1.ReplyContent
 */
export const ReplyContent = /*@__PURE__*/ proto3.makeMessageType(
  "social.stream.entity.v1.ReplyContent",
  () => [
    { no: 1, name: "titleurl", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "content", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "content_original", jsonName: "content_original", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "created", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "created_display", jsonName: "created_display", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "userid", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 8, name: "username", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "fullname", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 10, name: "avatar", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 11, name: "images", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 12, name: "topics", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 13, name: "mask_html", jsonName: "mask_html", kind: "message", T: MaskHtml, repeated: true },
    { no: 14, name: "images_data", jsonName: "images_data", kind: "message", T: ImageData, repeated: true },
    { no: 15, name: "image_frame_type", jsonName: "image_frame_type", kind: "enum", T: proto3.getEnumType(FrameType) },
  ],
);

/**
 * @generated from message social.stream.entity.v1.Analytics
 */
export const Analytics = /*@__PURE__*/ proto3.makeMessageType(
  "social.stream.entity.v1.Analytics",
  () => [
    { no: 1, name: "impression", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "engagement", kind: "message", T: AnalyticsEngagement },
  ],
);

/**
 * @generated from message social.stream.entity.v1.AnalyticsEngagement
 */
export const AnalyticsEngagement = /*@__PURE__*/ proto3.makeMessageType(
  "social.stream.entity.v1.AnalyticsEngagement",
  () => [
    { no: 1, name: "like", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "reply", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "share", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 4, name: "profile_view", jsonName: "profile_view", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 5, name: "sign_click", jsonName: "sign_click", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 6, name: "media_click", jsonName: "media_click", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
);

/**
 * @generated from message social.stream.entity.v1.Reports
 */
export const Reports = /*@__PURE__*/ proto3.makeMessageType(
  "social.stream.entity.v1.Reports",
  () => [
    { no: 1, name: "type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message social.stream.entity.v1.Stream
 */
export const Stream = /*@__PURE__*/ proto3.makeMessageType(
  "social.stream.entity.v1.Stream",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "titleurl", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "content", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "content_original", jsonName: "content_original", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "created", kind: "message", T: Timestamp },
    { no: 7, name: "mask_html", jsonName: "mask_html", kind: "message", T: MaskHtml, repeated: true },
    { no: 8, name: "images_data", jsonName: "images_data", kind: "message", T: ImageData, repeated: true },
    { no: 9, name: "image_frame_type", jsonName: "image_frame_type", kind: "enum", T: proto3.getEnumType(FrameType) },
    { no: 10, name: "attachments", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 11, name: "parent_id", jsonName: "parent_id", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 12, name: "user", kind: "message", T: User },
  ],
);

/**
 * @generated from message social.stream.entity.v1.User
 */
export const User = /*@__PURE__*/ proto3.makeMessageType(
  "social.stream.entity.v1.User",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "username", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "country", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "avatar", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message social.stream.entity.v1.ReplyInfo
 */
export const ReplyInfo = /*@__PURE__*/ proto3.makeMessageType(
  "social.stream.entity.v1.ReplyInfo",
  () => [
    { no: 1, name: "user", kind: "message", T: User },
  ],
);

/**
 * @generated from message social.stream.entity.v1.SpamStream
 */
export const SpamStream = /*@__PURE__*/ proto3.makeMessageType(
  "social.stream.entity.v1.SpamStream",
  () => [
    { no: 1, name: "stream_id", jsonName: "stream_id", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "post_url", jsonName: "post_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "created_at", jsonName: "created_at", kind: "message", T: Timestamp },
    { no: 4, name: "status", kind: "enum", T: proto3.getEnumType(SpamStatus) },
    { no: 5, name: "content", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "user", kind: "message", T: User },
    { no: 7, name: "images_data", jsonName: "images_data", kind: "message", T: ImageData, repeated: true },
    { no: 8, name: "reason", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message social.stream.entity.v1.Pagination
 */
export const Pagination = /*@__PURE__*/ proto3.makeMessageType(
  "social.stream.entity.v1.Pagination",
  () => [
    { no: 1, name: "current_page", jsonName: "current_page", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "total_data_in_page", jsonName: "total_data_in_page", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "total_data", jsonName: "total_data", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
);

/**
 * @generated from message social.stream.entity.v1.Liker
 */
export const Liker = /*@__PURE__*/ proto3.makeMessageType(
  "social.stream.entity.v1.Liker",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "username", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "email", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "fullname", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "avatar", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "about", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "followed", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 8, name: "is_verified", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * @generated from message social.stream.entity.v1.FollowingActivity
 */
export const FollowingActivity = /*@__PURE__*/ proto3.makeMessageType(
  "social.stream.entity.v1.FollowingActivity",
  () => [
    { no: 1, name: "users", kind: "message", T: User, repeated: true },
    { no: 2, name: "info", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message social.stream.entity.v1.News
 */
export const News = /*@__PURE__*/ proto3.makeMessageType(
  "social.stream.entity.v1.News",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "source", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "source_url", jsonName: "source_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "created_at", jsonName: "created_at", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "image", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message social.stream.entity.v1.Research
 */
export const Research = /*@__PURE__*/ proto3.makeMessageType(
  "social.stream.entity.v1.Research",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "category_label", jsonName: "category_label", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "image_url", jsonName: "image_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "icon_url", jsonName: "icon_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "created_at", jsonName: "created_at", kind: "message", T: Timestamp },
  ],
);

/**
 * @generated from message social.stream.entity.v1.Insider
 */
export const Insider = /*@__PURE__*/ proto3.makeMessageType(
  "social.stream.entity.v1.Insider",
  () => [
    { no: 1, name: "symbol", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "date", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "shareholder", kind: "message", T: Insider_Shareholder },
    { no: 4, name: "type", kind: "enum", T: proto3.getEnumType(Insider_Type) },
    { no: 5, name: "action", kind: "enum", T: proto3.getEnumType(Insider_Action) },
    { no: 6, name: "change", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "current", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "previous", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "corp_action", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from enum social.stream.entity.v1.Insider.Type
 */
export const Insider_Type = /*@__PURE__*/ proto3.makeEnum(
  "social.stream.entity.v1.Insider.Type",
  [
    {no: 0, name: "TYPE_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "TYPE_LOCAL", localName: "LOCAL"},
    {no: 2, name: "TYPE_FOREIGN", localName: "FOREIGN"},
  ],
);

/**
 * @generated from enum social.stream.entity.v1.Insider.Action
 */
export const Insider_Action = /*@__PURE__*/ proto3.makeEnum(
  "social.stream.entity.v1.Insider.Action",
  [
    {no: 0, name: "ACTION_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "ACTION_BOUGHT", localName: "BOUGHT"},
    {no: 2, name: "ACTION_SOLD", localName: "SOLD"},
  ],
);

/**
 * @generated from message social.stream.entity.v1.Insider.Shareholder
 */
export const Insider_Shareholder = /*@__PURE__*/ proto3.makeMessageType(
  "social.stream.entity.v1.Insider.Shareholder",
  () => [
    { no: 1, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "id", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
  {localName: "Insider_Shareholder"},
);

